import { Modal } from '../Common/Modal';
import { SkeletonLoader } from '../Common/SkeletonLoader';
import FooterSkeleton from './FooterSkeleton';

/**
 * Skeleton body without the `<Modal>` chrome. `EmbeddedPreferredPaymentView`
 * reuses it as the wallet-gate overlay so the boot skeleton and the gate
 * stay the same shape.
 */
export const EmbeddedPreferredSkeletonContent = () => {
  return (
    <div data-testid="embedded-preferred-skeleton" className="flex h-full w-full flex-col bg-white">
      <div className="flex min-h-0 flex-1 flex-col">
        <div className="flex flex-col pt-3">
          <div className="h-5 w-full" />
          <div className="mt-2 px-4">
            <SkeletonLoader height="h-20" />
          </div>
        </div>
        <div className="mt-4 w-full border-t border-base-border" />
        <div className="flex w-full flex-col gap-5 px-4 pb-5 pt-6">
          <SkeletonLoader height="h-12" />
          <div className="flex flex-col items-center gap-2">
            <SkeletonLoader width="w-65" height="h-3" />
            <SkeletonLoader width="w-65" height="h-3" />
          </div>
        </div>
      </div>
      <FooterSkeleton />
    </div>
  );
};

/** Boot skeleton for `EmbeddedPreferredPaymentView`: summary card, one CTA, footer. */
const EmbeddedPreferredSkeleton = () => {
  return (
    <Modal>
      <EmbeddedPreferredSkeletonContent />
    </Modal>
  );
};

export default EmbeddedPreferredSkeleton;
